/*
 * @Author: 唐亿开
 * @Date: 2020-09-30 10:11:53
 * @Last Modified by: Jerry.yanzhiwei
 * @Last Modified time: 2020-10-20 22:02:26
 */
<template>
   <div class="maintain_pages">
     <div class="header">
       <img :src="logo" alt="">
     </div>
     <div class="main_container">
      <img class="tips_img" :src="tipsImg" alt="">

      <div class="notice_box">
        <p class="notice">System Maintenance Notice</p>

        <div class="content">
          <p class="honorific_title">Dear Users:</p>
          <p class="text">The system is under maintenance, from <span>{{params.startTime}}</span> to <span>{{params.endTime}}</span>. During this period, the system is not accessible. Sorry for the incovenience and thank you for your understanding!</p>
        </div>

        <div class="signature">
          <p>Contact us：support@school365.org.cn</p>
          <p>Powered by School365</p>
        </div>
      </div>

      <div class="link"></div>

      <div class="notice_box">
        <p class="notice">系统维护通知</p>

        <div class="content">
          <p class="honorific_title">尊敬的用户：</p>
          <p class="honorific_title">您好！</p>
          <p class="text">本系统正在维护中，本次维护从 <span>{{params.startTime}}</span> 开始 <span>{{params.endTime}}</span>  结束。在此期间，系统不可访问。给您带来不便，敬请谅解！</p>
        </div>

        <div class="signature">
          <p>联系我们：support@school365.org.cn</p>
          <p>技术支持：School365</p>
        </div>
      </div>
     </div>
   </div>
</template>

<script>
// import { mapGetters } from "vuex';"
import logo from '@res/images/maintain/logo.png'
import tipsImg from '@res/images/maintain/tipsimg.png'
import { parseTime } from '@/utils/timer/index'

export default {
  name: 'maintain',
  props: {},
  data () {
    return {
      logo,
      tipsImg,
      params: {}
    }
  },
  components: {},
  created () {
    this.params = JSON.parse(sessionStorage.getItem('maintainInfo'))
    this.params.startTime = parseTime(this.params.startTime, '{y}-{m}-{d} {h}:{i}')
    this.params.endTime = parseTime(this.params.endTime, '{y}-{m}-{d} {h}:{i}')
  },
  mounted () {},
  computed: {},
  watch: {},
  methods: {},
  beforeDestroy () {}
}
</script>
<style lang="scss" scoped>
.maintain_pages {
  width: 100%;
  .header {
    height: 70px;
    line-height: 70px;
    padding-left: 30px;
    img {
      height: 30px;
    }
  }
  .main_container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1000px;
    height: 786px;
    margin: 0 auto;

    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.25);
    border: 1px solid #F3F4F9;
    .tips_img {
      width: 243px;
      height: 140px;
      margin-top: 45px;
      margin-bottom: 30px;
      object-fit: cover;
    }

    .notice_box {
      padding: 0 100px;
      .notice {
        text-align: center;
        margin-bottom: 30px;
        font-size: 24px;
        font-weight: 600;
        color: #2D2D2D;
      }

      .content {
        margin-bottom: 40px;
        font-size: 14px;
        font-weight: 500;
        color: #2D2D2D;
        line-height: 20px;
        .honorific_title {
          margin-bottom: 8px;
        }
        .text {
          text-indent: 2em;
          span {
            color: #0094DA;
          }
        }
      }

      .signature {
        margin-bottom: 40px;
        text-align: right;
        font-size: 14px;
        font-weight: 400;
      }
    }

    .link {
      margin: 0 100px;
      margin-bottom: 40px;
      width: 800px;
      height: 1px;
      background: #E6E7F0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/maintain/pages/index.vue